import { cacheKeys } from "@constants/cache-keys";
import useCacheKey from "@hooks/useCacheKey";
import type { ExamDetails } from "@memorang/types";
import { useQueryClient } from "@tanstack/react-query";
import type { AppContextCache } from "types/apps";
import { useExamContext } from "./ExamContext";

const useMultipleExams = () => {
	const { appContextCacheKey } = useCacheKey();

	const {
		currentExamContext: { examId },
	} = useExamContext();

	const queryClient = useQueryClient();
	const appContextData = queryClient.getQueryData<AppContextCache>([
		cacheKeys.cache,
		appContextCacheKey || "",
	]);

	const selectedState = appContextData?.selectedStates?.[0];
	const selectedStateId = selectedState?.code;

	const cachedExams = queryClient.getQueryData<ExamDetails[]>([
		cacheKeys.exams,
	]);
	const examWithState = cachedExams?.find(
		(exam) => exam.exam.state && exam.exam.state?.code === selectedStateId,
	);

	const relatedExamsIds = selectedState?.relatedExamsIds ?? [];

	const relatedExams =
		cachedExams?.filter((exam) =>
			exam.exam.id === examId && Boolean(examWithState) && exam.exam.state
				? false
				: relatedExamsIds.includes(exam.exam.id),
		) || [];

	const stateAlias = examWithState?.exam.state;

	return {
		examWithState,
		relatedExams,
		selectedStateId,
		stateAlias,
		relatedExamsIds,
		cachedExams,
	};
};

export default useMultipleExams;
